
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^webpack_sharing_consume_default_react(\-native_(assets\-registry_(path\-support_react\-native_assets\-35f154|registry_react\-native_assets\-reg\-5d1eae)|normalize\-colors_react\-native_normalize\-colors\-w\-1304b7|src_private_featureflags_ReactNativeFeatureFlags\-fd3090|virtualized\-lists_react\-native_virtualized\-lists)|_react)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
